module.exports = __webpack_public_path__ + "img/StaMaria.a3021f84.png";